import React from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import BackgammonPage from "../Backgammon/BackgammonPage";

function DijonBackgammon(props) {
  return (
    <div id="backgammon-card">
      <DijonCard
        width={"92vw"}
        height={"92vh"}
        defaultX={0}
        startMaximized
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={"backgammon"}
        content={
          <div style={{ height: "100%", width: "100%", overflow: "auto", position: "relative" }}>
            <BackgammonPage />
          </div>
        }
      />
    </div>
  );
}

export default DijonBackgammon;
